<script lang="ts">
  import {
    sendPasswordResetEmail,
    signInWithEmailAndPassword,
    type UserCredential,
  } from "firebase/auth";
  import AuthCard from "./AuthCard.svelte";
  import { createEventDispatcher } from "svelte";
  import { firebaseAuth } from "app/utils/firebase/client";
  import { alerts } from "$stores/alert";
  import { signUpUrl } from "$utils/urls";
  import { createUser } from "$utils/auth";

  export let inModal = false;
  export let showSignupLink = true;

  const dispatch = createEventDispatcher();
  let firebaseError: string;
  let submitting = false;
  function signIn(email: string, password: string) {
    signInWithEmailAndPassword(firebaseAuth, email, password)
      .then(() => dispatch("authed"))
      .catch((error) => {
        submitting = false;
        firebaseError = "An unknown error occurred, please check your details and try again.";
        if (error.message.includes("invalid-email")) {
          firebaseError = "Please enter a valid email";
        } else if (
          error.message.includes("wrong-password") ||
          error.message.includes("INVALID_PASSWORD")
        ) {
          firebaseError = "Invalid email/password";
        } else if (error.message.includes("user-not-found")) {
          firebaseError = "Invalid email, user not found";
        }
      });
  }

  function resetPassword(email: string) {
    try {
      sendPasswordResetEmail(firebaseAuth, email).then(() => {
        alerts.success(`Password reset sent to ${email}`);
      });
    } catch (error) {
      alerts.error(error as string);
    }
  }

  async function checkAndCreateUser(user: UserCredential, isNewUser: boolean) {
    if (isNewUser) {
      const success = await createUser(user, "");
      if (!success) {
        firebaseError = "Error logging in, please try again";
        return;
      }
    }
    dispatch("authed", { user, isNewUser: true });
  }
</script>

<AuthCard
  on:submit={(event) => signIn(event.detail.email, event.detail.password)}
  on:reset={(event) => resetPassword(event.detail.email)}
  on:authed={(ev) => checkAndCreateUser(ev.detail.user, ev.detail.isNewUser)}
  bind:submitting
  buttonText="Continue with email"
  heading={inModal ? "Log in via Outverse" : "Log in to Outverse"}
  emailPlaceholder="Email"
  hasBackground={inModal}
  showOutverseLogo={!inModal}
  showResetPassword
>
  <div slot="subheading" class="pt-4 text-sm font-medium">
    {#if showSignupLink}
      {#if inModal}
        <button on:click|stopPropagation={() => dispatch("requestSignup")} class="text-blue-300">
          <span class="text-neutral-400">Don't have an Outverse account?</span>
          <span class="whitespace-nowrap">Sign up</span>
        </button>
      {:else}
        <a href={signUpUrl()} class="text-blue-300">
          <span class="text-neutral-400">Don't have an Outverse account?</span>
          <span class="whitespace-nowrap">Sign up</span>
        </a>
      {/if}
    {/if}
  </div>

  <div slot="error">
    {#if firebaseError}
      {firebaseError}
    {/if}
  </div>
</AuthCard>
